import { Fragment } from "react";
import SenderDetails from "../SenderDetails";
import ReceivingMap from "../ReceivingMap";
import ParcelInfo from "./ParcelInfo";
import ReceiverDetails from "../ReceiverDetails";

const ParcelPointForm = ({ type,payment_type }) => {
    return <Fragment>
        <SenderDetails />
        <div style={{ margin: "3vh" }} />
        {(type.includes('pp_')) && (<ParcelInfo type={type } payment_type={payment_type}/>)}
        <div style={{ margin: "2vh" }} />
        <ReceiverDetails type={type} />
    </Fragment>
}

export default ParcelPointForm;